<!-- =========================================================================================
  File Name: SponsorEdit.vue
  Description: Sponsor Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<template>
  <div id="page-user-edit" class="attendee-form-wrap">
    <div class="header-custome">
      <h3>Add Exhibitor</h3>
    </div>
    <vs-alert color="danger" title="Attendee Not Found" :active.sync="exhibitor_not_found">
      <span>Sponsor record with id: {{ $route.params.exhibitorId }} not found.</span>
      <span>
        <span>Check</span>
        <router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <vx-card v-if="exhibitor_data">
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs position="left" v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Exhibitor" icon-pack="feather" icon="icon-user">
            <div class="tab-text">
              <exhibitor-edit-tab-account :ContactAdmins="ContactAdmins" :data="exhibitor_data" />
            </div>
          </vs-tab>
          
          <!-- <vs-tab label="Social" icon-pack="feather" icon="icon-share-2">
            <div class="tab-text">
              <exhibitor-edit-tab-social class="mt-4" :data="exhibitor_data" />
            </div>
          </vs-tab> -->
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>

<script>
import ExhibitorEditTabAccount from "./ExhibitorEditTabAccount.vue";
import ExhibitorEditTabSocial from "./ExhibitorEditTabSocial.vue";

// Store Module
import moduleExhibitorManagement from "@/store/exhibitor-management/moduleExhibitorManagement.js";

export default {
  components: {
    ExhibitorEditTabAccount,
    ExhibitorEditTabSocial
  },
  data() {
    return {
      exhibitor_data: null,
      exhibitor_not_found: false,

      /*
        This property is created for fetching latest data from API when tab is changed

        Please check it's watcher
      */
      activeTab: 0,
      checkView: false,
      ContactAdmins: []
    };
  },
  watch: {
    activeTab() {
      this.fetch_exhibitor_data();
    }
  },
  methods: {
    fetch_exhibitor_data() {
      this.$store
        .dispatch("exhibitorManagement/fetchExhibitor", null)
        .then(res => {
          this.exhibitor_data = res.data;
          this.exhibitor_data.ariealView = this.checkView;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.exhibitor_not_found = true;
            return;
          }
          console.error(err);
        });
    },
    fetchExhibitorSettings(){
      this.$store.dispatch("exhibitorManagement/getSettings").then((res) => {
        if(res.AllowAerialView){
          this.checkView = true;
        }else{
          this.checkView = false;
        }
        this.fetch_exhibitor_data(this.$route.params.exhibitorId);
      });
    }
  },
  created() {
    //debugger;
    // Register Module UserManagement Module
    if (!moduleExhibitorManagement.isRegistered) {
      this.$store.registerModule("exhibitorManagement", moduleExhibitorManagement);
      moduleExhibitorManagement.isRegistered = true;
    }
    this.fetchExhibitorSettings();
  
  }
};
</script>